import { Timestamp, } from 'firebase/firestore';
import { PART_TRAINING_LABEL_TYPES, } from '../parts/parts';
const LABEL_SET = new Set(PART_TRAINING_LABEL_TYPES);
const parseLabel = (raw) => typeof raw === 'string' && LABEL_SET.has(raw) ? raw : 'other';
const parseSource = (raw) => raw === 'inspection' || raw === 'damage' || raw === 'inventory' ? raw : 'inventory';
const parseBox = (raw) => {
    if (!raw || typeof raw !== 'object')
        return undefined;
    const box = raw;
    const x = Number(box.x);
    const y = Number(box.y);
    const width = Number(box.width);
    const height = Number(box.height);
    if (![x, y, width, height].every((value) => Number.isFinite(value)))
        return undefined;
    return { x, y, width, height };
};
const parseTimestamp = (raw) => raw instanceof Timestamp ? raw : Timestamp.fromDate(new Date(0));
export const partTrainingLabelConverter = {
    toFirestore(label) {
        return label;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return {
            vehicle_id: typeof data.vehicle_id === 'string' ? data.vehicle_id : '',
            vehicle_label: typeof data.vehicle_label === 'string' ? data.vehicle_label : undefined,
            photo_url: typeof data.photo_url === 'string' ? data.photo_url : '',
            photo_path: typeof data.photo_path === 'string' ? data.photo_path : undefined,
            photo_source: parseSource(data.photo_source),
            label: parseLabel(data.label),
            box: parseBox(data.box),
            labeled_by: typeof data.labeled_by === 'string' ? data.labeled_by : '',
            labeled_by_name: typeof data.labeled_by_name === 'string' ? data.labeled_by_name : undefined,
            created_at: parseTimestamp(data.created_at),
            updated_at: parseTimestamp(data.updated_at),
        };
    },
};
